import { render, staticRenderFns } from "./secretaryList.vue?vue&type=template&id=5e40ca6e&scoped=true&"
import script from "./secretaryList.vue?vue&type=script&lang=js&"
export * from "./secretaryList.vue?vue&type=script&lang=js&"
import style0 from "./secretaryList.vue?vue&type=style&index=0&id=5e40ca6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40ca6e",
  null
  
)

export default component.exports